import React, { FC, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { LeaderboardConfigFragment } from 'api';
import { EmptyState, Layouts } from 'components';
import { useUserLeaderboards } from 'hooks';

import LeaderboardSelect from '../components/Select';
import Leaderboard from '../components/Leaderboard';
import LeaderboardLoader from '../components/Loader';

const LeaderboardIndex: FC = () => {
  const navigate = useNavigate();
  const params = useParams<{ leaderboard_id: string }>();
  const userLeaderboards = useUserLeaderboards();

  const paramConfig = userLeaderboards.find(conf => conf.id === params.leaderboard_id);
  const [firstConfig] = userLeaderboards;
  const config = paramConfig || firstConfig;

  const [currentConfig, setCurrentConfig] = useState<LeaderboardConfigFragment>(config);

  useEffect(() => {
    navigate(`/leaderboard/${config.id}`, { replace: true });
  }, []);

  useEffect(() => {
    if (params.leaderboard_id) {
      setCurrentConfig(paramConfig);
    }
  }, [params]);

  if (!userLeaderboards.length) {
    return <Layouts.App1Column main={<EmptyState name="leaderboardIndex" />} />;
  }

  return (
    <Layouts.App2Column
      mainWidth="wide"
      sidebar={<LeaderboardSelect configs={userLeaderboards} />}
      main={currentConfig ? <Leaderboard config={currentConfig} /> : <LeaderboardLoader />}
    />
  );
};

export default LeaderboardIndex;
